import { 
    cookieNames,
    removeAfterCheckoutRedirection,
    getAfterLoginRedirection,
    removeAfterLoginRedirection,
    removeSkipAfterCheckoutOnboard,
    protectedApiCall,
    sentryAPIErrorV2,
    showSpinner,
    checkoutLink,
    websiteUrl,
} from './module_common';

import {
    firebaseSetLanguageCode, 
    firebaseGetCurrentUser,
    firebaseSendVerificationEmail,
    firebaseOnAuthStateChanged,
} from './module_firebase';

import { openModal } from './module_modal';

import Cookies from 'js-cookie'

let redirectToProfileOnProblemSendingEmailModalClose = true

function sendVerificationEmail_send(user, uid, code, ntm){
    const verificationUrl = websiteUrl() + LL + '/verify?uid=' + uid + '&vc=' + code
    //Redirects after verification
    const actionCodeSettings = {
        url: verificationUrl
    };
    // user.sendEmailVerification(actionCodeSettings)
    firebaseSendVerificationEmail(user, actionCodeSettings)
        .then(function () {
            $("#verifyEmailModal").on("hidden.bs.modal", function(){
                document.body.dispatchEvent(new CustomEvent("emailVerificationFlowDone"))
                if (ntm) needToMove(true);
            })
            openModal('#verifyEmailModal', 'sendVerificationEmail_send')
        })
        .catch(function (err) {
            const contextData = {
                apicalldata:{
                    function: "sendVerificationEmail_send",
                    status: err.status,
                    response: err.responseJSON,
                    uid: UIDg,
                }
            }
            const error = new Error('Error sendind verification email')
            error.name = 'sendVerificationEmail_send fail'
            sentryAPIErrorV2(error, contextData)
            $("#problemSendingEmailModal").on("hidden.bs.modal", function(){
                document.body.dispatchEvent(new CustomEvent("emailVerificationFlowDone"))
                if (!redirectToProfileOnProblemSendingEmailModalClose) return
                window.location.href = '/' + LL + '/profilo';
            })
            openModal('#problemSendingEmailModal', 'sendVerificationEmail_send')
        });
}

export function doNotRedirectToProfileOnProblemSendingEmailModalClose(){
    redirectToProfileOnProblemSendingEmailModalClose = false
}

export function needToMove(reload) {
    reload = reload || false;
    const url = getAfterLoginRedirection();
    if (url) {
        showSpinner();
        removeAfterLoginRedirection()
        sessionStorage.setItem('mustReloadOnBack', location.href)
        window.location.href = url;
    } else {
        if (reload) {
            showSpinner();
            location.reload();
        }
    }
}

export function cleanCheckoutSetting() {
    removeAfterCheckoutRedirection()
    removeSkipAfterCheckoutOnboard()
}

function openResendEmail(uid, verifycode, ntm){
    $("#resendemail").on("click", function(){
        sendVerificationEmail(uid, verifycode, ntm);
    })
    openModal("#resendEmailModal", "openResendEmail")
}

export function reVerifyEmailAndOpenResendPopup(planRequested){
    protectedApiCall(
        'GET', 
        '/users/' + UIDg + '?preventCache=' + new Date(), 
        null,
        function (resp) {
            if (resp['user']) {
                if (resp['user']['user_verified']) {
                    redirectToCheckoutPage(planRequested);
                }
                else {
                    cleanCheckoutSetting();
                    openResendEmail(UIDg, resp['user']['vc'], false)
                }
            } else {
                cleanCheckoutSetting();
                openModal("#requestProblemTryLogoutModal", "reVerifyEmailAndOpenResendPopup")
            }
        },
        function (err) {
            cleanCheckoutSetting();
            openModal("#requestProblemTryLogoutModal", "reVerifyEmailAndOpenResendPopup")
        });
}

export function redirectToCheckoutPage(plan){
    preCheckoutActions()
    const queryString = allPlans[plan]['chkQueryString']
    window.location.href = `${checkoutLink}${queryString}`
}

export function preCheckoutActions(){
    // pushDataLayerData()   
    // TODO
    // check if the functions below are really needed
    Cookies.remove(cookieNames.guestSubscribing); // check where is used 
    
    // ---- redirect url set in php ----
    // ---------------------------------
    // const thankyoupageUrl = getThankyoupageUrl() 
    // if (thankyoupageUrl !== ""){
    //     setSkipAfterCheckoutOnboard()
    //     setAfterCheckoutRedirection(thankyoupageUrl)
    // }
}

export function sendVerificationEmail(uid, code, ntm = false) {
    firebaseSetLanguageCode(LL)
    let user = firebaseGetCurrentUser();
    if (user){
        sendVerificationEmail_send(user, uid, code, ntm);
    }else{
        const unsubscribeFromStateChange = firebaseOnAuthStateChanged((user)=>{
            if (user) {
                sendVerificationEmail_send(user, uid, code, ntm);
                // detach the listener
                unsubscribeFromStateChange();
            }
        })
    }
}

// used for offer page
export function getThankyoupageUrl(){
    const el = $('.goto-data')
    if (el.length){
        return el.data('goto')
    }
    return ""
}
